import { render, staticRenderFns } from "./siderFavoritesAssistants.vue?vue&type=template&id=866229e4&scoped=true&"
import script from "./siderFavoritesAssistants.vue?vue&type=script&lang=js&"
export * from "./siderFavoritesAssistants.vue?vue&type=script&lang=js&"
import style0 from "./siderFavoritesAssistants.vue?vue&type=style&index=0&id=866229e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "866229e4",
  null
  
)

export default component.exports